<template>
  <div class="dataFee">
    <div class="box">
      <!-- 头部 -->
      <div class="header_box">
        <div class="h_back" @click="$router.go(-1)">
          <span><i class="iconfont icon-shangchuanicon-fuben"></i></span>
          <!-- <span>返回</span> -->
        </div>
        <div class="title">
          <span>{{type== 1 ? '销售附加费统计' : '成本费用统计'}}</span>
        </div>
      </div>
      <!-- 中间工具栏 -->
      <!-- <div class="tool_box">

      </div> -->
      <!-- 列表 -->
      <div class="list_table" v-if="type == 1">
        <div class="table_header">
          <div class="table_tr">
            <div>附加费名称</div>
            <div>数量(个)</div>
            <div>单价(元/个)</div>
            <div>小计(元)</div>
            <div>买家</div>
            <div>操作员</div>
          </div>
        </div>
        <div class="table_body">
          <md-scroll-view ref="dataFeeScrollView" :scrolling-x="false" manual-init @end-reached="handleDataMore" :auto-reflow="true">
            <div class="table_tr" v-for="(item,index) in list" :key="index">
              <div class="mand-ellipsis">{{item.name}}</div>
              <div class="mand-ellipsis">{{item.num_total-0}}</div>
              <div class="mand-ellipsis">{{item.price}}</div>
              <div class="mand-ellipsis">{{item.price_total}}</div>
              <div class="mand-ellipsis">{{item.buyer_name}}</div>
              <div class="mand-ellipsis">{{item.realname}}</div>
            </div>
            <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="isFinished" > </md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>  
      <div class="list_table" v-if="type == 2">
        <div class="table_header">
          <div class="table_tr">
            <div>费用类型</div>
            <div>费用名称</div>
            <div>费用金额(元)</div>
            <div>货主</div>
            <div>操作员</div>
          </div>
        </div>
        <div class="table_body">
          <md-scroll-view ref="dataFeeScrollView" :scrolling-x="false" manual-init @end-reached="handleDataMore" :auto-reflow="true">
            <div class="table_tr" v-for="(item,index) in list" :key="index">
              <div class="mand-ellipsis"><span v-if="item.type == 1">产地费用</span><span v-if="item.type == 2">市场费用</span></div>
              <div class="mand-ellipsis">{{item.name}}</div>
              <div class="mand-ellipsis">{{item.price_total}}</div>
              <div class="mand-ellipsis">{{item.supplier_name}}</div>
              <div class="mand-ellipsis">{{item.realname}}</div>
            </div>
            <md-scroll-view-more :finished-text="list.length>0?'全部已加载':'暂无数据'" slot="more" :is-finished="isFinished" > </md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>  
    </div>
  </div>
</template>
<script>
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import { saleFee_data,costFee_data} from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
export default {
  name: "dataFee",
  data() {
    return {
      show:false,
      type:"",
      isFinished:false,
      listQuery:{
        type:'',
        keyword:'',
        from_time:'',
        to_time:'',
        page:1,
        pageSize:15,
      },
      list:[],
    };
  },
  created() {
    this.type = this.$route.query.type
    this.getList()
  },
  mounted() {},
  methods: {
    // 获取列表
    getList(){
      if(this.type == 1){
        saleFee_data(this.listQuery).then(res=>{
          if(res.code == 200 ){
            this.getRes(res)
          }
        })
      }else{
        costFee_data(this.listQuery).then(res=>{
          if(res.code == 200 ){
            this.getRes(res)
          }
        })
      }
    },
    // 拿到res的处理
    getRes(res){
      if(this.listQuery.page == 1) this.list = []
      this.list = this.list.concat(res.data.list)
      if(this.list.length >= res.data.totalCount || res.data.list.length == 0){
          this.isFinished = true;
      }else{
          this.isFinished = false;
          this.listQuery.page++;
      }
      this.$refs.dataFeeScrollView.init()
    },
    
    // 上拉加载更多数据
    handleDataMore() {
      if (this.isFinished) {
        return
      }
      this.$refs.dataFeeScrollView.finishLoadMore()
      this.getList()
    },
  }
};
</script>
<style lang="less" scoped>
.dataFee {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0.1rem 0.1rem 0;
  .box{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 0.05rem 0.05rem 0 0;
    .header_box{
      height: 0.7rem;
      display: flex;
      padding: 0 0.2rem;
      align-items: center;
      justify-content: flex-start;
      box-shadow: 0 0.04rem 0.1rem 0.04rem #e1e1e1;
      .h_back{
        font-size: 0.24rem;
        span{
          margin-right: 0.1rem;
        }
        i{
          font-size: 0.24rem;
        }
      }
      .title{
        font-size: 0.28rem;
        font-weight: bold;
        line-height: 0.7rem;
        padding-left: 0.2rem;
      }
    }
    .list_table{
      width: 100%;
      height: calc(100% - 0.7rem);
      padding: 0.1rem 0.1rem 0;
      .table_header{
        font-weight: bold;
        line-height: 0.6rem;
      }
      .table_body{
        height: calc(100% - 0.69rem);
      }
      .table_tr{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: 0.01rem solid #e5e5e5;
        line-height: 0.6rem;
        &>div{
          padding: 0 0.2rem;
          width: 16%;
          text-align: center;
        }
      }
    }
  }
}
</style>